// export const answerQuestions = createAsyncThunk(
import AsyncStorage from "@react-native-async-storage/async-storage";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API } from "../config/apis";
import i18n from 'i18next';

export const answerQuestions = createAsyncThunk(
  'answerQuestions',
  async (_, { rejectWithValue }) => {
    try {
        const userData = await AsyncStorage.getItem('Data');
        const parseUserData = JSON.parse(userData);
        const token = parseUserData?.token;
        const userId = parseUserData?.userId;
        console.log('userToken',token);
        console.log('userId',userId);
        const response = await axios.post(API.GET_PROFILE_API, {
          userId,
        },{
          headers:{
              Authorization: `Bearer ${token}`,
              'Accept-Language': i18n.language === 'dt' ? 'du' : 'en',
          },
        });
        return response.data.Data.has_answered;
    } catch (err) {
      console.log('answerQuestions error',err.response);
      return rejectWithValue(err.response.data.Message);
    }
  }
);

    const answerSlice = createSlice({
      name: 'answer',
      initialState: {
        has_answered: false,
        answerLoading: false,
        error: null,
      },
      extraReducers: builder => {
        builder.addCase(answerQuestions.pending, (state) => {
          state.answerLoading = true;
          state.error = null;
        });
        builder.addCase(answerQuestions.fulfilled, (state, action) => {
          console.log('answerQuestions fulfilled',action.payload);
          state.answerLoading = false;
          state.has_answered = action.payload;
          state.error = null;
        });
        builder.addCase(answerQuestions.rejected, (state, action) => {
          state.answerLoading = false;
          state.error = action.payload || 'Failed to answer questions';
        });
      },
    });
  
  export default answerSlice.reducer;